import React, { useState } from "react";
import "react-dropdown/style.css";

const SearchHead = ({ data, list, searchChange, searchValue }) => {
    const [selectedOption, setSelectedOption] = useState(() => list[0]);
    const [options, setOptions] = useState(() => list.slice(1));
    const [showSeries, setShowSeries] = useState(2);
    const [showPublishers, setShowPublishers] = useState(2);
    const [showAuthors, setShowAuthors] = useState(2);
    const [showSpeechers, setShowSpeechers] = useState(2);

    const onSelect = (item) => {
        setSelectedOption(item);
        searchChange(item.value);
        setOptions(list.filter((se) => se.value !== item.value));
    };
    const getOptions = (option, attribute, url) => {
        if (option.length > 0) {
            return option
                .map((item) => {
                    return {
                    value: item?.title ?? item?.name ?? item?.lastname + " " + item?.firstname,
                    url: item.list_url,
                }});
        }
        return [];
    };

    const contentData = data?.content?.data;
    const optionsObj = {
        publishers: contentData?.publishers ? getOptions(contentData.publishers, "publisher") : [],
        authors: contentData?.authors
            ? getOptions(contentData.authors, "authorname", "authorurl")
            : [],
        speechers: contentData?.speechers ? getOptions(contentData.speechers, "reader") : [],
        series: contentData?.series ? getOptions(contentData.series, "series") : [],
    };
    const areOptionsEmpty = Object.values(optionsObj).every((value) => value.length === 0);

    const renderOption = (option, title, showOption, setShowOption) => {
        return (
            <>
                {optionsObj[option].length > 0 && (
                    <>
                        <li className="search-item search-item-title">
                            <a href="#">{title}</a>
                        </li>
                        {optionsObj[option].slice(0, showOption).map((item) => (
                            <li className="search-item" key={item.value}>
                                <a href={item.url}>{item.value}</a>
                            </li>
                        ))}
                        <li
                            className={`search-item search-item-show-more${
                                optionsObj[option].length <= showOption
                                    ? " hide-search-show-more"
                                    : ""
                            }`}
                            onClick={() => setShowOption(showOption + 2)}
                        >
                            Mutass többet
                        </li>
                    </>
                )}
            </>
        );
    };

    return (
        <>
            {!areOptionsEmpty && (
                <ul className="search-list search-list--desktop">
                    {renderOption("series", "Sorozatok", showSeries, setShowSeries)}
                    {renderOption("publishers", "Kiadók", showPublishers, setShowPublishers)}
                    {renderOption("authors", "Szerzők", showAuthors, setShowAuthors)}
                    {renderOption("speechers", "Felolvasók", showSpeechers, setShowSpeechers)}
                </ul>
            )}

            {/*<Dropdown*/}
            {/*    className="search-list--mobile"*/}
            {/*    options={options}*/}
            {/*    onChange={onSelect}*/}
            {/*    value={selectedOption}*/}
            {/*    placeholder="Select an option"*/}
            {/*/>*/}
        </>
    );
};

export default SearchHead;
